import { render } from "./ManagePeople.vue?vue&type=template&id=f9f0b1e2&scoped=true"
import script from "./ManagePeople.vue?vue&type=script&lang=js"
export * from "./ManagePeople.vue?vue&type=script&lang=js"

import "./ManagePeople.vue?vue&type=style&index=0&id=f9f0b1e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9f0b1e2"]])

export default __exports__